import { getSecondsFromTimeDuration } from 'utils/format_date'

const COLON_SEPARATOR = ':'

const VALIDATION_MESSAGES = {
  nameRequired: 'Name is required',
  nameLength: 'Name must be between 1 and 128 characters',
  descriptionLength: 'Description cannot be longer than 255 characters',
  expirationFormat: 'Expiration duration should be in DD:HH:MM format',
  expirationValid: 'Expiration duration must be between 00:00:15 and 07:00:00',
}

export const getMillisecondsFromDMTime = time => {
  let seconds
  try {
    seconds = getSecondsFromTimeDuration(time, true)
  } catch {
    seconds = 0
  }

  return seconds * 1000
}

export const validateForm = values => {
  const { name, description, expirationDuration } = values
  const errors = {}

  if (!name.trim()) {
    errors.name = VALIDATION_MESSAGES.nameRequired
  } else if (name.length > 128) {
    errors.name = VALIDATION_MESSAGES.nameLength
  }

  if (description.length > 255) {
    errors.description = VALIDATION_MESSAGES.descriptionLength
  }

  if (!expirationDuration.trim()) {
    errors.expirationDuration = VALIDATION_MESSAGES.expirationFormat
  } else {
    const [days, hours, minutes] = expirationDuration
      .split(COLON_SEPARATOR)
      .map(Number)
    const isValid =
      !isNaN(hours) &&
      !isNaN(minutes) &&
      !isNaN(days) &&
      days >= 0 &&
      days <= 7 &&
      hours >= 0 &&
      hours <= 23 &&
      minutes >= 0 &&
      minutes <= 59
    const totalMilliseconds = getMillisecondsFromDMTime(expirationDuration)
    const isWithinRange =
      totalMilliseconds >= getMillisecondsFromDMTime('00:00:15') &&
      totalMilliseconds <= getMillisecondsFromDMTime('07:00:00')
    if (!isValid || !isWithinRange) {
      errors.expirationDuration = VALIDATION_MESSAGES.expirationValid
    }
  }

  return errors
}

export const isResourceProfile = () => {
  return location.pathname.includes('/resources-manager/profile-management')
}
